import React, { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from "@material-ui/core";
import * as auth from "../../store/ducks/auth.duck";
import { register } from "../../crud/auth.crud";
import Swal from "sweetalert2";
import { Col, Row } from "react-bootstrap";
import InputMask from 'react-input-mask';
import { Link, Redirect } from "react-router-dom";
import { buscaCep } from "../../utils/Utils";
import { validateFormCadastro } from "./AuthUtils";

function Register(props) {
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [step, setStep] = useState('primeiro');

	const submitCadastro = (values, setStatus) => {
		setLoading(true);

		register(values).then(res => {
			if (res.status === 200) {
				setLoading(false);

				Swal.fire('Sucesso', 'O usuário foi cadastrado com sucesso. Realize o login na plataforma.', 'success');

				setSuccess(true);
			}
		}).catch(err => {
			setLoading(false);

			let error = err?.response?.data?.errors?.length > 0
				? err?.response?.data?.errors[0]
				: null;

			if (!error) {
				return Swal.fire('Ops', 'Ocorreu um erro ao tentar realizar o seu cadastro. Por favor, entre em contato com o suporte.', 'error');
			}

			setStatus(error)
		});
	};

	const getInitialValues = () => {
		return {
			email: '',
			password: '',
			nome: '',
			cpf: '',
			celular: '',
			data_nascimento: '',
			sexo: 'Masculino',
			cep: '',
			endereco: '',
			numero: '',
			bairro: '',
			complemento: '',
			estado: '',
			cidade: '',
		};
	}

	return (
		<>
			<div className="kt-login__head">
			</div>

			<div className="kt-login__body">
				<div className="kt-login__form">
					<div className="kt-login__title">
						<h3>Familiar - Registrar</h3>
					</div>

					{success && <Redirect to="/login" />}

					<Formik initialValues={getInitialValues()} validate={values => validateFormCadastro(values)} onSubmit={(values, { setStatus }) => submitCadastro(values, setStatus)}>
						{({ values, status, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
							<form noValidate={true} autoComplete="off" className="kt-form" onSubmit={handleSubmit}>
								{status &&
									<div role="alert" className="alert alert-danger">
										<div className="alert-text">{status}</div>
									</div>
								}

								{step === 'primeiro' &&
									<>
										<Row>
											<Col sm={12}>
												<TextField label="Nome *" margin="normal" name="nome" onBlur={handleBlur} onChange={handleChange}
													value={values.nome} helperText={touched.nome && errors.nome} error={Boolean(touched.nome && errors.nome)} />
											</Col>
										</Row>
										<Row>

											<Col sm={12}>
												<TextField type="email" label="Email *" margin="normal" name="email" onBlur={handleBlur} onChange={handleChange}
													value={values.email} helperText={touched.email && errors.email} error={Boolean(touched.email && errors.email)} />
											</Col>
										</Row>

										<Row>
											<Col sm={6}>
												<InputMask mask="999.999.999-99" onBlur={handleBlur} onChange={handleChange} value={values.cpf}>
													{() =>
														<TextField label="CPF *" margin="normal" name="cpf" onBlur={handleBlur} onChange={handleChange}
															value={values.cpf} helperText={touched.cpf && errors.cpf} error={Boolean(touched.cpf && errors.cpf)} />
													}
												</InputMask>
											</Col>
											<Col sm={6}>
												<InputMask mask="(99) 99999-9999" onBlur={handleBlur} onChange={handleChange} value={values.celular}>
													{() =>
														<TextField label="Celular *" margin="normal" name="celular" onBlur={handleBlur} onChange={handleChange}
															value={values.celular} helperText={touched.celular && errors.celular} error={Boolean(touched.celular && errors.celular)} />
													}
												</InputMask>
											</Col>
										</Row>
										<Row>
											<Col sm={6}>
												<TextField label="Data de nascimento *" type="date" margin="normal" name="data_nascimento" InputLabelProps={{ shrink: true }} onBlur={handleBlur} onChange={handleChange}
													value={values.data_nascimento} helperText={touched.data_nascimento && errors.data_nascimento} error={Boolean(touched.data_nascimento && errors.data_nascimento)} />
											</Col>
											<Col sm={6} className="mt-2">
												<FormControl>
													<FormLabel id="demo-controlled-radio-buttons-group">Sexo</FormLabel>
													<RadioGroup row aria-labelledby="row-radio-buttons-group" name="sexo" value={values.sexo} onChange={handleChange} className="d-flex justify-content-between" >
														<FormControlLabel value="Feminino" control={<Radio />} label="Feminino" />
														<FormControlLabel value="Masculino" control={<Radio />} label="Masculino" />
													</RadioGroup>
												</FormControl>
											</Col>
										</Row>
										<Row>
											<Col sm={12}>
												<TextField label="Senha *" type="password" margin="normal" name="password" onBlur={handleBlur} onChange={handleChange}
													value={values.password} helperText={touched.password && errors.password} error={Boolean(touched.password && errors.password)} />
											</Col>
										</Row>
									</>

								}

								{step === 'segundo' &&
									<>
										<Row>
											<Col sm={12}>
												<InputMask mask="99999-999" onBlur={(e) => handleBlur(buscaCep(e, setFieldValue, 'endereco', 'bairro', 'cidade', 'estado'))} onChange={handleChange} value={values.cep}>
													{() =>
														<TextField label="CEP *" margin="normal" name="cep"
															value={values.cep} helperText={touched.cep && errors.cep} error={Boolean(touched.cep && errors.cep)} />
													}
												</InputMask>
											</Col>
										</Row>
										<Row>
											<Col sm={8}>
												<TextField label="Endereço *" margin="normal" name="endereco" onBlur={handleBlur} onChange={handleChange}
													value={values.endereco} helperText={touched.endereco && errors.endereco} error={Boolean(touched.endereco && errors.email)} />
											</Col>
											<Col sm={4}>
												<TextField label="Número *" margin="normal" name="numero" onBlur={handleBlur} onChange={handleChange}
													value={values.numero} helperText={touched.numero && errors.numero} error={Boolean(touched.numero && errors.numero)} />
											</Col>
										</Row>
										<Row>
											<Col sm={6}>
												<TextField label="Bairro *" margin="normal" name="bairro" onBlur={handleBlur} onChange={handleChange}
													value={values.bairro} helperText={touched.bairro && errors.bairro} error={Boolean(touched.bairro && errors.bairro)} />
											</Col>
											<Col sm={6}>
												<TextField label="Complemento " margin="normal" name="complemento" onBlur={handleBlur} onChange={handleChange}
													value={values.complemento} helperText={touched.complemento && errors.complemento} error={Boolean(touched.complemento && errors.complemento)} />
											</Col>
										</Row>
										<Row>
											<Col sm={6}>
												<TextField label="Estado *" margin="normal" name="estado" onBlur={handleBlur} onChange={handleChange}
													value={values.estado} helperText={touched.estado && errors.estado} error={Boolean(touched.estado && errors.estado)} />
											</Col>
											<Col sm={6}>
												<TextField label="Cidade *" margin="normal" name="cidade" onBlur={handleBlur} onChange={handleChange}
													value={values.cidade} helperText={touched.cidade && errors.cidade} error={Boolean(touched.cidade && errors.cidade)} />
											</Col>
										</Row>
									</>
								}


								<div className="mt-5">
									{step === 'primeiro' &&
										<div className="d-flex justify-content-between">
											<Link className="btn btn-danger btn-bold" to="/"><i className="fa fa-arrow-left margin-icon"></i><b>Login</b></Link>

											<button disabled={loading} type="button" className="btn btn-primary btn-bold d-flex justify-content-end" onClick={() => setStep('segundo')}>
												<i className={`margin-icon ${loading ? "fas fa-sync fa-spin" : "fa fa-arrow-right"}`} />Avançar
											</button>
										</div>
									}

									{step === 'segundo' &&
										<div className="d-flex justify-content-between">
											<button disabled={loading} type="button" className="btn btn-danger btn-bold" onClick={() => setStep('primeiro')}>
												<i className={`margin-icon fa fa-arrow-left`} />Voltar
											</button>

											<button disabled={loading} type="submit" className="btn btn-success btn-bold">
												<i className={`margin-icon ${loading ? "fas fa-sync fa-spin" : "fa fa-check-square"}`} />Enviar
											</button>
										</div>
									}
								</div>
							</form>
						)}
					</Formik>
				</div>
			</div>
		</>
	);
}

export default connect(null, auth.actions)(Register)

